/*
 * @format
 */

import * as actionTypes from '../action-types';

export const STATES = {
  NOT_STARTED: 'notStarted',
  STARTED: 'started',
  PENDING: 'pending',
  TIMEOUT: 'timeout',
  COMPLETE: 'complete',
};

export const initialState = {
  registrationStatus: STATES.NOT_STARTED,
  heatType: 'boiler',
};

export const siRegistration = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SI_REGISTRATION_RESET:
      console.log('si registration RESET');
      return { ...state, registrationStatus: STATES.NOT_STARTED };
    case actionTypes.SI_REGISTRATION_STARTED:
      console.log('si registration STARTED');
      return { ...state, registrationStatus: STATES.STARTED };
    case actionTypes.SI_REGISTRATION_COMPLETION_STARTED:
      console.log('si registration PENDING');
      return { ...state, registrationStatus: STATES.PENDING };
    case actionTypes.WEBSOCKET_HELLO_MESSAGE_RECEIVED:
      if (state.registrationStatus === STATES.PENDING) {
        console.log('si registration COMPLETE');
        return { ...state, registrationStatus: STATES.COMPLETE };
      }

      return state;
    case actionTypes.SI_REGISTRATION_COMPLETION_TIMEOUT:
      if (state.registrationStatus === STATES.PENDING) {
        return { ...state, registrationStatus: STATES.TIMEOUT };
      }

      return state;

    case actionTypes.SET_HEAT_TYPE:
      return { ...state, heatType: action?.heatType };
    default:
      return state;
  }
};
